// Cart drawer reviews. "More" shows the whole review, clicking a review that is partly out of view
// brings it in, and a mouse drags the row like a finger: it follows the pointer, then glides on at
// the speed it was let go and settles on a review. Touch and trackpads scroll it natively. The
// listeners are on the document because the drawer's contents are re-rendered after every cart change.
let drag = null;
let glide = null;
let dragged = false;

// The scroll positions that center each review, as the row's scroll snapping places them.
function reviewStops(list) {
  const max = list.scrollWidth - list.clientWidth;
  const origin = list.getBoundingClientRect().left - list.scrollLeft;
  return [...list.children].map((review) => {
    const box = review.getBoundingClientRect();
    return Math.min(Math.max(box.left - origin + box.width / 2 - list.clientWidth / 2, 0), max);
  });
}

const nearestStop = (stops, position) =>
  stops.reduce((best, stop) => (Math.abs(stop - position) < Math.abs(best - position) ? stop : best));

function stopGlide() {
  if (!glide) return;
  cancelAnimationFrame(glide.frame);
  glide.list.classList.remove('is-gliding');
  glide = null;
}

// Eases the row out to a stop. An ease-out cubic starts at 3 × distance / duration, so a duration
// of 3 × distance / speed carries on at the speed (px/ms) the row was let go at.
function glideTo(list, target, speed = 0) {
  stopGlide();
  const from = list.scrollLeft;
  const distance = target - from;
  const carry = speed && Math.sign(speed) === Math.sign(distance) ? (3 * distance) / speed : 0;
  const duration = Math.min(Math.max(carry, 350), 900);
  const start = performance.now();
  const step = (now) => {
    const progress = Math.min((now - start) / duration, 1);
    list.scrollLeft = from + distance * (1 - (1 - progress) ** 3);
    if (progress < 1) glide.frame = requestAnimationFrame(step);
    else stopGlide();
  };
  list.classList.add('is-gliding');
  glide = { list, frame: requestAnimationFrame(step) };
}

document.addEventListener('pointerdown', (event) => {
  const list = event.target.closest('.cart-reviews__list');
  if (!list) return;

  stopGlide();
  if (event.pointerType !== 'mouse' || event.button !== 0) return;
  drag = { list, id: event.pointerId, x: event.clientX, left: list.scrollLeft, moving: false, moves: [] };
});

document.addEventListener('pointermove', (event) => {
  if (!drag || event.pointerId !== drag.id) return;

  if (!drag.moving) {
    if (Math.abs(event.clientX - drag.x) < 6) return;
    drag.moving = true;
    drag.list.classList.add('is-dragging');
    try {
      drag.list.setPointerCapture(event.pointerId);
    } catch {}
  }
  drag.list.scrollLeft = drag.left - (event.clientX - drag.x);

  // The last 100ms of movement give the speed the row is let go at.
  drag.moves.push({ x: event.clientX, time: event.timeStamp });
  while (event.timeStamp - drag.moves[0].time > 100) drag.moves.shift();
});

function endDrag(event) {
  if (!drag || event.pointerId !== drag.id) return;

  const { list, moving, moves } = drag;
  drag = null;
  if (!moving) return;

  list.classList.remove('is-dragging');
  // The click that ends a drag is not a click on a review.
  dragged = true;
  setTimeout(() => (dragged = false));

  // Scroll speed in px/ms, none if the pointer had stopped before it was let go. Like a flick on a
  // touch screen, the row runs on about a quarter second's worth before it settles.
  const first = moves[0];
  const last = moves[moves.length - 1];
  const flicked = event.timeStamp - last.time < 80 && last.time > first.time;
  const speed = flicked ? (first.x - last.x) / (last.time - first.time) : 0;
  glideTo(list, nearestStop(reviewStops(list), list.scrollLeft + speed * 250), speed);
}

document.addEventListener('pointerup', endDrag);
document.addEventListener('pointercancel', endDrag);

// A trackpad swipe during a glide takes over from it.
document.addEventListener(
  'wheel',
  (event) => {
    if (glide && event.target.closest?.('.cart-reviews__list')) stopGlide();
  },
  { passive: true }
);

document.addEventListener(
  'click',
  (event) => {
    if (!dragged) return;
    event.preventDefault();
    event.stopPropagation();
  },
  true
);

document.addEventListener('click', (event) => {
  const review = event.target.closest('.cart-review');
  if (!review) return;

  const list = review.parentElement;
  const row = list.getBoundingClientRect();
  const box = review.getBoundingClientRect();
  if (box.left < row.left - 1 || box.right > row.right + 1) {
    glideTo(list, reviewStops(list)[[...list.children].indexOf(review)]);
    return;
  }

  const toggle = event.target.closest('[data-review-toggle]');
  if (!toggle) return;

  const expanded = review.classList.toggle('is-expanded');
  toggle.setAttribute('aria-expanded', expanded);
  toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
});
